import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '../../translations/getTranslation';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import { Paragraph } from '../../components/Styled/typography';
import { ReplacementCardOnlineChatButton } from '../../components/Button';
import useAccountSummary from '../../hooks/useAccountSummary';
import useAnalytics from '../../hooks/useAnalytics';
const UnableSubmit = () => {
    const { isSuccess, isSemu } = useAccountSummary();
    useAnalytics(isSuccess, { isSemu });
    return (_jsxs(MainLayout, Object.assign({ withImage: true }, { children: [_jsx(LayoutHeading, { title: t('unableSubmit.weAreUnable'), modalImageProps: { imageName: 'API_ERROR' } }), _jsxs(Paragraph, { children: [t('unableSubmit.pleaseContact'), _jsx(ReplacementCardOnlineChatButton, {}), "."] })] })));
};
export default UnableSubmit;
//# sourceMappingURL=index.js.map